import { Component } from "@angular/core";

@Component({
    selector: "time-balance-mail",
    template: require('./time-balance-mail.component.html')
})
export class TimeBalanceMailComponent {

}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/time-balance-mail.component.ts